export default __webpack_public_path__ + "static/media/image-web-design-large.8fe8b44b.jpg";